import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';

import { LocationStrategy, PathLocationStrategy } from '@angular/common';
import { MessageService } from '@progress/kendo-angular-l10n';
import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { environment } from '../environments/environment';
import { JwtInterceptor } from './auth';
import { ErrorInterceptor } from './auth/error.interceptor';
import { LanguageInterceptor } from './auth/language.interceptor';
import { CustomMessagesService } from './services/translation/custom-messages.service';
import { Constants } from './util/constants';

@NgModule({
    imports: [HttpClientModule],
    providers: [
        { provide: LocationStrategy, useClass: PathLocationStrategy },
        { provide: MessageService, useExisting: CustomMessagesService },
        { provide: LOCALE_ID, useValue: Constants.LOCALE_EN },
        { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.siteKey },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: JwtInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: LanguageInterceptor,
            multi: true
        }
    ]
})
export class CoreModule {}
